import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

/* 公共路由(静态路由) */
import pubRouter from "./modules/pub";
import h5Router from "./modules/h5";

/* 权限路由(异步路由) */
import nationwideRouter from "./modules/nationwide";
import govRouter from "./modules/gov";
import screenRouter from "./modules/screen";
import schoolRouter from "./modules/school";
import gradeRouter from "./modules/grade";
import clazzRouter from "./modules/clazz";
import schooldoctorRouter from "./modules/schooldoctor";
import fifteenRouter from "./modules/fifteen";

/* 公共路由 */
var _constantRoutes = [];
_constantRoutes = _constantRoutes.concat(pubRouter);
_constantRoutes = _constantRoutes.concat(h5Router);
export var constantRoutes = _constantRoutes;

/* 权限路由 */
var _asyncRoutes = [];
_asyncRoutes = _asyncRoutes.concat(govRouter);
_asyncRoutes = _asyncRoutes.concat(screenRouter);
_asyncRoutes = _asyncRoutes.concat(schoolRouter);
_asyncRoutes = _asyncRoutes.concat(gradeRouter);
_asyncRoutes = _asyncRoutes.concat(schooldoctorRouter);
_asyncRoutes = _asyncRoutes.concat(clazzRouter);
_asyncRoutes = _asyncRoutes.concat(nationwideRouter);
_asyncRoutes = _asyncRoutes.concat(fifteenRouter);
_asyncRoutes.push({
  path: "*",
  redirect: "/404",
  hidden: true
}); //404页面放在最后
export var asyncRoutes = _asyncRoutes;

//创建路由
var createRouter = function createRouter() {
  return new Router({
    mode: "history",
    // require service support
    base: process.env.BASE_URL,
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();

//重置路由
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

//路由跳转后触发的事件
router.afterEach(function (to) {
  //解决 Vue history模式 微信API IOS无效 
  if (window.__wxjs_is_wkwebview) {
    // IOS微信浏览器里
    if (window.entryUrl == '' || window.entryUrl == undefined) {
      var base = process.env.BASE_URL.substring(0, process.env.BASE_URL.length - 1);
      var url = "".concat(window.location.origin).concat(base).concat(to.fullPath);
      window.entryUrl = url;
    }
  }
});
export default router;